import { IonBackButton, IonButton, IonButtons, IonContent, IonHeader, IonImg, IonPage, IonTitle, IonToolbar, isPlatform } from "@ionic/react"
import { TextField } from "@mui/material";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { useSelector } from "react-redux";

import { RouteComponentProps, withRouter } from "react-router";
import { login } from "../../data/slices/auth";
import { RootState, useAppDispatch } from "../../data/store";
import { LoginFormData } from "../../models/userModel";
import { isValidEmail } from "../../util/validation";

import "./Login.scss";

const Login: React.FC<RouteComponentProps> = ({ history, match }) => {
    const { control, handleSubmit, formState: { errors } } = useForm<LoginFormData>();
    const dispatch = useAppDispatch();
    const onSubmit: SubmitHandler<LoginFormData> = (data) => {
        dispatch(login(data))
        history.push("/tabs/start")
    };
    const darkMode: boolean = useSelector((state: RootState) => state.user.darkMode)

    const handleEmailValidation = (email: string) => {
        const isValid = isValidEmail(email);

        const validityChanged =
            (errors.email && isValid) || (!errors.email && !isValid);
        if (validityChanged) {
            console.log("Fire tracker with", isValid ? "Valid" : "Invalid");
        }

        if (isValid) {
            return isValid;
        } else {
            return "Keine gültige E-Mail Adresse"
        }

    };

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>Login</IonTitle>
                    <IonButtons slot="start">
                        <IonBackButton text={isPlatform('ios') ? "Zurück" : undefined}/>
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent >
                <div className="loginContainer">
                    <IonImg src={darkMode ? "./assets/images/logo-big.png" : "./assets/images/logo-big-dark.png"} className="loginLogo" alt="Hachenbach Logo" />
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Controller
                            name="email"
                            control={control}
                            defaultValue=""
                            rules={{
                                required: { value: true, message: "Bitte geben Sie eine E-Mail-Adresse an" },
                                validate: { value: handleEmailValidation }
                            }}
                            render={({ field }) =>
                                <TextField {...field}
                                    variant="filled"
                                    label="E-Mail"
                                    error={errors.email ? true : false}
                                    helperText={errors.email && errors.email.message}
                                    aria-invalid={errors.email ? true : false}
                                    className="loginField"
                                />
                            }
                        />
                        <Controller
                            name="password"
                            control={control}
                            defaultValue=""
                            rules={{
                                required: { value: true, message: "Bitte geben Sie ihr Passwort ein" },
                            }}
                            render={({ field }) =>
                                <TextField {...field}
                                    variant="filled"
                                    label="Passwort"
                                    type="password"
                                    error={errors.password ? true : false}
                                    helperText={errors.email && errors.email.message}
                                    aria-invalid={errors.email ? true : false}
                                    className="loginField"
                                />
                            }
                        />
                        <IonButton expand="block" type="submit">Login</IonButton>
                    </form>
                </div>
            </IonContent>
        </IonPage>
    )
}

export default withRouter(Login);
